
import { DanaPackingSlipResult } from "@dana/Services/DanaOrderRelatedService";
import { SalseOrgDetails } from "@dana/Services/StandardReturnDetailsService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

// Define the state type for this fetch workflow
export interface DanaPackingSlipState {
    isLoading: boolean,
    data: any,    // Use a more specific type if known
    salseOrgDetails?: SalseOrgDetails,
    error: string | null,
}

const initialPackingSlipState: DanaPackingSlipState = {
    isLoading: false,
    data: null,
    error: null
};

// Create Immer reducer
const danaPackingSlipReducer = createTypedReducerWithImmer(initialPackingSlipState, {
    // Start loading
    "DanaPackingSlip/IsLoading": (draft, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
        if (action.isLoading) {
            draft.error = null; // Optionally reset error if reloading
        }
    },

    // Populate result on success
    "DanaPackingSlip/PopulateResult": (draft, action: { data: DanaPackingSlipResult }) => {
        action.data.packingSlipDetails = {
            ...action.data.packingSlipDetails,
            shipPlantName: action.data.salseOrgDetails.orgName,
            shipPlantAddress1: action.data.salseOrgDetails.orgAddress,
            shipPlantCountry: action.data.salseOrgDetails.country,
        }
        draft.data = action.data.packingSlipDetails;
        draft.isLoading = false;
        draft.error = null;
    },

    // Handle error
    "DanaPackingSlip/FetchError": (draft, action: { error: string }) => {
        draft.error = action.error;
        draft.isLoading = false;
    },

    // Reset all state (optional)
    "DanaPackingSlip/Reset": draft => {
        draft.isLoading = false;
        draft.data = null;
        draft.error = null;
    }
});

// Register reducer in the root
(reducers as any).danaPackingSlip = danaPackingSlipReducer;

// Define type for action usage
type DanaPackingSlipReducers = {
    danaPackingSlip: typeof danaPackingSlipReducer;
};

export type DanaPackingSlipActions = Parameters<DanaPackingSlipReducers[keyof DanaPackingSlipReducers]>[1] | AnyAction;
